var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OneAction',{attrs:{"icon":"icons/Visuals/ic_warning_visuals_connected-to-another-user_200.svg","text1":_vm.titleT,"text2":_vm.descT,"action":_vm.btnT,"warning":true},on:{"tap":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }